import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import {
  Identifiable,
  Planzone,
  PlanzoneSettings,
  ProjectDetailsConfiguration,
} from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  configuration: ProjectDetailsConfiguration;
  retrieveProjectDetailsConfiguration(
    req: Boundaries["retrieveProjectDetailsConfiguration"]["request"],
  ): void;
}

function useRetrieveProjectDetailsConfiguration(
  planzone: Identifiable<Planzone>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveProjectDetailsConfigurationRequestPending(planzone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveProjectDetailsConfigurationRequestSuccess(planzone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveProjectDetailsConfigurationRequestFailure(planzone),
    ),
    configuration: useSelector(() =>
      selector.getProjectDetailsConfiguration(planzone),
    ),
    retrieveProjectDetailsConfiguration:
      core.retrieveProjectDetailsConfiguration,
  };
}

export { useRetrieveProjectDetailsConfiguration };
